export default class EDChild {

    validateElement(pElement) {

        return true
    }

    appendElement(pElement) {

        if(pElement && this.validateElement(pElement)) {
            
            pElement.setParent(this._parent)
            this._children.set(pElement.getDOMId(), pElement)

            if(this._parent._DOMElement) {
                pElement.render()
            }

            return pElement.getDOMId()
        }
        
    }

    append(pElement) {

        if(pElement) {

            pElement = Array.isArray(pElement) ? pElement : new Array(pElement)
            pElement.forEach(el =>{

                this.appendElement(el)
            })
        }
    }

    has(pName) {
        return this._children.has(pName)
    }

    remove(pName) {
        this._children.delete(pName)
    }

    get(pName) {
        return this._children.get(pName)
    }

    render() {
        this._children.forEach((element, name) => {
            element.render()
        })
    }

    unrender() {
        this._children.forEach((element) => {
            element.unrender()
        })
        this._children.clear()
    }

    count() {
        return this._children.size
    }

    getKeyArray() {
        return Array.from(this._children.keys())
    }

    getById(pId) {

        const keys = this.getKeyArray()
        
        if(keys[pId]) {
            return this._children.get(keys[pId])
        }
    }

    constructor(pParent, pAppend) {

        this._parent = pParent
        this._children = new Map()
        this.append(pAppend)
    }

}